<template>
  <div class="jump">
    <div v-if="needSelect" class="mch-panel">
      <div class="brand">惠通达</div>
      <div class="slogan">惠民通达，支付无忧</div>
      <div class="hint">请选择收款商户</div>
      <div v-if="!merchants.length" class="hint">暂无可选商户，请联系管理员配置商户池</div>
      <button
        v-for="item in merchants"
        :key="item.mchNo + '-' + item.appId"
        class="mch-item"
        @click="chooseMch(item)"
      >
        <div class="mch-name">{{ item.mchName || item.mchNo }}</div>
        <div class="mch-sub">{{ item.storeName || item.mchNo }}</div>
      </button>
    </div>
    <img v-else src="@/assets/images/loading.gif" alt="" />
  </div>
</template>

<script>
import { getRedirectUrl, getPayOrderInfo } from '@/api/api'
import config from '@/config'

const MCH_KEY = 'huitongda_selected_mch_no'
const QRC_KEY = 'huitongda_selected_qrc_id'

export default {
  data() {
    return {
      needSelect: false,
      merchants: []
    }
  },
  mounted() {
    const that = this
    getPayOrderInfo().then(res => {
      if (res && res.qrcId && sessionStorage.getItem(QRC_KEY) !== res.qrcId) {
        sessionStorage.removeItem(MCH_KEY)
        sessionStorage.setItem(QRC_KEY, res.qrcId)
      }
      if (res && res.needSelectMch) {
        const selected = sessionStorage.getItem(MCH_KEY)
        that.merchants = res.merchants || []
        if (!selected) {
          that.needSelect = true
          return
        }
      }
      that.goPay()
    }).catch(res => {
      that.$router.push({ name: config.errorPageRouteName, params: { errInfo: res.msg } })
    })
  },
  methods: {
    chooseMch(item) {
      sessionStorage.setItem(MCH_KEY, item.mchNo)
      this.needSelect = false
      this.goPay()
    },
    goPay() {
      const that = this
      getRedirectUrl().then(res => {
        location.href = res
      }).catch(res => {
        that.$router.push({ name: config.errorPageRouteName, params: { errInfo: res.msg } })
      })
    }
  }
}
</script>
<style lang="css" scoped>
  .jump {
    min-height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f7fb;
  }
  .mch-panel {
    width: 86%;
    max-width: 420px;
    background: #fff;
    border-radius: 16px;
    padding: 24px 18px 18px;
    box-shadow: 0 10px 30px rgba(11, 31, 58, 0.08);
  }
  .brand {
    font-size: 24px;
    font-weight: 700;
    color: #0B1F3A;
    text-align: center;
  }
  .slogan {
    margin-top: 6px;
    text-align: center;
    color: #C9A227;
    font-size: 13px;
  }
  .hint {
    margin: 18px 0 10px;
    color: #0B5CAB;
    font-size: 14px;
  }
  .mch-item {
    width: 100%;
    text-align: left;
    border: 1px solid #e6edf5;
    background: #fff;
    border-radius: 10px;
    padding: 12px 14px;
    margin-bottom: 10px;
  }
  .mch-name {
    color: #0B1F3A;
    font-size: 16px;
    font-weight: 600;
  }
  .mch-sub {
    margin-top: 4px;
    color: #7a8699;
    font-size: 12px;
  }
</style>
